import { AutoComplete } from "./Suggestions";
import { Box } from "@vinomofo/components";
import { InstantSearch } from "react-instantsearch-core";
import SearchBox from "./SearchBox";
import algoliasearch from "algoliasearch";
import { useSearch } from "../../hooks/use-search";

const DEFAULT_SEARCH_PLACEHOLDER = "Search our stories...";

const searchClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID,
  process.env.GATSBY_ALGOLIA_SEARCH_KEY
);

interface SearchHeaderProps {
  __typename?: string;
  title?: string;
  placeholder?: string;
  flavourTitle?: string;
  flavourText?: string;
}

export const ArticleSearchHeader = ({
  title,
  placeholder,
  flavourTitle,
  flavourText,
}: SearchHeaderProps): JSX.Element => {
  const { query, showSuggestions } = useSearch();

  return (
    <Box display="flex" alignItems="flex-end" style={{marginTop:"20px"}}>
      <Box flexBasis={["100%", "100%"]} position="relative">
        <SearchBox
          placeholder={placeholder || DEFAULT_SEARCH_PLACEHOLDER}
          title=""
        />
        {showSuggestions && (
          <InstantSearch
            indexName={
              process.env.GATSBY_ALGOLIA_ARTICLES_INDEX
            }
            searchClient={searchClient}
          >
            <AutoComplete defaultRefinement={query} />
          </InstantSearch>
        )}
      </Box>
    </Box>
  );
};
